<script>
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import timeGridPlugin from '@fullcalendar/timegrid'
  import interactionPlugin from '@fullcalendar/interaction'
  import { INITIAL_EVENTS, createEventId } from './event-utils'

  export default {
    name: "full-calander",
    components: {
      FullCalendar // make the <FullCalendar> tag available
    },

    data: function () {
      return {
        calendarOptions: {
          plugins: [
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin // needed for dateClick
          ],
          headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
          },
          initialView: 'dayGridMonth',
          initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
          //events: //'/api/AdminEntity/GetLocationShifts?locationId=0',         
          editable: true,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true,
          weekends: true,
          select: this.handleDateSelect,
          eventClick: this.handleEventClick,
          eventsSet: this.handleEvents
          /* you can update a remote database when these fire:
          eventAdd:
          eventChange:
          eventRemove:
          */
        },
        currentEvents: []
      }
    },

    methods: {

      handleWeekendsToggle() {
        this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
      },

      handleDateSelect(selectInfo) {
        let title = prompt('Please enter a new title for your event')
        let calendarApi = selectInfo.view.calendar

        calendarApi.unselect() // clear date selection
        
        if (title) {
          calendarApi.addEvent({
            id: createEventId(),
            title,
            start: selectInfo.startStr,
            end: selectInfo.endStr,
            allDay: selectInfo.allDay
          })
        }
      },

      handleEventClick(clickInfo) {
        if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
          clickInfo.event.remove()
        }
      },

      handleEvents(events) {
        this.currentEvents = events
      },
      eventRender(info) {
        //alert(info);
        console.log(info);

      },

      fetchData(selectInfo) {
        let calendarApi = this.$refs.fullCalendar.getApi();
        //alert(selectInfo.startStr);
        //alert(selectInfo.endStr);
        //let calendarApi = selectInfo.view.calendar
        //var a = INITIAL_EVENTS;
        //calendarApi.unselect(); // clear date selection
        //$.each(INITIAL_EVENTS, function (index, value) {
        //  alert(value.title);
        //  calendarApi.addEvent({
        //    id: value.id,
        //    title: value.title,
        //    start: value.title,
        //    end: value.title,
        //    extendedProps: {
        //      department: value.extendedProps.department,
        //      url: value.extendedProps.url
        //    },
        //  });
        //});
        //if (title) {
        //  calendarApi.addEvent({
        //    id: createEventId(),
        //    title,
        //    start: selectInfo.startStr,
        //    end: selectInfo.endStr,
        //    allDay: selectInfo.allDay
        //  })
        //}


        return [
          {
            id: 0,
            title: 'event1',//'All-day event',
            start: new Date().toISOString().replace(/T.*$/, ''),
            url: '',
            extendedProps: {
              department: 'BioChemistry',
              url: '/api/membership/GetSquareImage?username=erikbohm@hotmail.com'
            },
          },
          //{
          //  id: createEventId(),
          //  title: 'Timed event',
          //  start: todayStr + 'T12:00:00'
          //}
        ];



        //return INITIAL_EVENTS;
      },
    }
  }
</script>

<template>
  <div class='demo-app' style="height:100%">
    <!--<div class='demo-app-sidebar'>
      <div class='demo-app-sidebar-section'>
        <h2>Instructions</h2>
        <ul>
          <li>Select dates and you will be prompted to create a new event</li>
          <li>Drag, drop, and resize events</li>
          <li>Click an event to delete it</li>
        </ul>
      </div>
      <div class='demo-app-sidebar-section'>
        <label>
          <input
            type='checkbox'
            :checked='calendarOptions.weekends'
            @change='handleWeekendsToggle'
          />
          toggle weekends
        </label>
      </div>
      <div class='demo-app-sidebar-section'>
        <h2>All Events ({{ currentEvents.length }})</h2>
        <ul>
          <li v-for='event in currentEvents' :key='event.id'>
            <b>{{ event.startStr }}</b>
            <i>{{ event.title }}</i>
          </li>
        </ul>
      </div>
    </div>-->
    <div class='demo-app-main'>
      <FullCalendar ref="fullCalendar"
                    class='demo-app-calendar'
                    :options='calendarOptions'>
        <template v-slot:eventContent='arg'>
          <!--<b>{{ arg.timeText }}</b>-->
          <!--<b>{{ arg.event.extendedProps.department }}</b>-->
          <img :src="arg.event.extendedProps.url" class="rounded-circle mr-2" alt="" height="34" width="34">
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
    </div>
  </div>
</template>

<style lang='css' scoped>

  h2 {
    margin: 0;
    font-size: 16px;
  }

  ul {
    margin: 0;
    padding: 0 0 0 1.5em;
  }

  li {
    margin: 1.5em 0;
    padding: 0;
  }

  b { /* used for event dates/times */
    margin-right: 3px;
  }

  .demo-app {
    display: flex;
    min-height: 100%;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
    width: 100%;
  }

  .demo-app-sidebar {
    width: 300px;
    line-height: 1.5;
    background: #eaf9ff;
    border-right: 1px solid #d3e2e8;
  }

  .demo-app-sidebar-section {
    padding: 2em;
  }

  .demo-app-main {
    flex-grow: 1;
    padding: 3em;
  }

  .fc { /* the calendar root */
    max-width: 1100px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/calander/full-calander.vue